
    import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

    @Component({
        name: 'table-show-range-body.vue',
    })
    export default class ShowMeasuringRange extends Vue {
        @Prop()
        paramList !: any;
        @Prop()
        params : any; // 测量范围参数名
    }
